import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { AuditHelperFunctions } from 'src/app/helpers/audit-helper-functions';
import { AuditPackedStructualDataDetailsViewModel } from 'src/app/models/audit-packed-structural-data-details-view-model';
import { AuditService } from 'src/app/services/audit.service';

@Component({
  selector: 'app-audit-packed-structural-data-details',
  templateUrl: './audit-packed-structural-data-details.component.html',
  styleUrls: ['./audit-packed-structural-data-details.component.scss']
})
export class AuditPackedStructuralDataDetailsComponent implements OnInit {
  @Input() merchantNumber: string;

  public dtOptions: DataTables.Settings;
  public dtTrigger: Subject<boolean> = new Subject();
  public auditPackedStructualDataDetailsViewModel: AuditPackedStructualDataDetailsViewModel[] = [];
  private auditHelperFunctions: AuditHelperFunctions;

  @ViewChild(DataTableDirective)
  public dtElement: DataTableDirective;
  dtInstance: Promise<DataTables.Api>;

  constructor(private _auditService: AuditService) {
    this.auditHelperFunctions = new AuditHelperFunctions();
  }

  async ngOnInit(): Promise<void> {
    this.dtOptions = {
      order: [''],
      pageLength: 10,
      pagingType: 'full_numbers'
    };
    this.auditPackedStructualDataDetailsViewModel = await this._auditService.GetPackedStructuralDataDetails(this.merchantNumber);
    this.dtTrigger.next();
  }

  public DownloadCsv(): void {
    this.auditHelperFunctions.DownloadCsv(this.auditPackedStructualDataDetailsViewModel, 'MerchantAuditTrail_PackedStructuralData_');
  }

  public print(): void {
    this.auditHelperFunctions.print();
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }
}
